module.exports = __webpack_public_path__ + "img/athletics_icon_1.87f402f7.png";